import { useDispatch } from "react-redux";
import ButtonBase from "@mui/material/ButtonBase";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { setIsSummaryModalOpen } from "../../redux/slices/customNavigation";

const ExitButton = ({ onClick }) => {
  const dispatch = useDispatch();
  return (
    <ButtonBase
      sx={{
        width: "2vw",
        height: "4vh",
        position: "absolute",
        top: 0,
        right: 0,
        borderRadius: "60px",
        marginRight: "2vh",
        marginTop: "2vh",
      }}
      onClick={onClick}
    >
      <CloseIcon></CloseIcon>
    </ButtonBase>
  );
};

export default ExitButton;
